import { LOC_ADDRESS_TYPE, LOC_ADDRESSEE, LOC_ATTRIBUTE_NAME, LOC_CLASS, LOC_EMAIL, LOC_TEXT } from "../../locKeys";
import { parseStringToBoolean } from "../../utils";
import { Action } from "./Action";

export class SendMail extends Action {
    public recipientType: SendMessageRecipientType;
    public recipient: string;
    public className: string;
    public attrName: string;
    public dataCondition: string;
    public subject: string;
    public text: string;
    public reportTemplate: string;
    public summaryMail: boolean;
    public format: MessageFormat;
    public documentClassName: string;
    public documentAttribute: string;
    public documentCondition: string;
    public documentConditionParams: string;
    public sendPostpone: boolean;

    constructor(recipientType: string, recipient: string, className: string, attrName: string, dataCondition: string, subject: string, text: string, reportTemplate: string, summaryMail: string, format: string, documentClassName: string, documentAttribute: string, documentCondition: string, documentConditionParams: string, sendPostpone: string, condition: string, comment: string) {
        super(condition, comment);

        this.recipientType = (SendMessageRecipientType as any)[recipientType];
        this.recipient = SendMail.isRecipientRequired(this.recipientType) ? recipient : "";
        this.className = className.trim();
        this.attrName = attrName.trim();
        this.dataCondition = dataCondition.trim();
        this.subject = subject;
        this.text = text;
        this.reportTemplate = reportTemplate;
        this.summaryMail = parseStringToBoolean(summaryMail, false);
        this.format = (MessageFormat as any)[format];
        this.documentClassName = documentClassName;
        this.documentAttribute = documentAttribute;
        this.documentCondition = documentCondition;
        this.documentConditionParams = documentConditionParams;
        this.sendPostpone = parseStringToBoolean(sendPostpone, false);
    }

    public override async validate(): Promise<void> {
        if (!this.recipientType)
            throw new Error(await this.getActionErrorMessage(LOC_ADDRESS_TYPE, LOC_EMAIL));

        if (this.recipientType === SendMessageRecipientType.condition) {
            if (!this.className)
                throw new Error(await this.getActionErrorMessage(LOC_CLASS, LOC_EMAIL));

            if (!this.attrName)
                throw new Error(await this.getActionErrorMessage(LOC_ATTRIBUTE_NAME, LOC_EMAIL));
        }

        if (SendMail.isRecipientRequired(this.recipientType) && !this.recipient)
            throw new Error(await this.getActionErrorMessage(LOC_ADDRESSEE, LOC_EMAIL));

        if (!this.text)
            throw new Error(await this.getActionErrorMessage(LOC_TEXT, LOC_EMAIL));
    }

    private static isRecipientRequired(recipientType: SendMessageRecipientType): boolean {
        return recipientType !== SendMessageRecipientType.actualUser
            && recipientType !== SendMessageRecipientType.owner
            && recipientType !== SendMessageRecipientType.participants
            && recipientType !== SendMessageRecipientType.nextParticipants
            && recipientType !== SendMessageRecipientType.condition;
    }
}

export enum MessageFormat {
    text = "text",
    HTML = "HTML",
}

export enum SendMessageRecipientType {
    value = "value",
    attributeValue = "attributeValue",
    actualUser = "actualUser",
    owner = "owner",
    participants = "participants",
    nextParticipants = "nextParticipants",
    role = "role",
    okruh = "okruh",
    condition = "condition",
}
